/* eslint-disable camelcase */
export default function getListDates(data, options = {}) {
  const withAvailableData = options.withAvailableData
    ? options.withAvailableData
    : true

  const dates = []
  data.forEach(dataItem => {
    dataItem.data.forEach(item => {
      if (dates.includes(item.date) || (withAvailableData && !item.data)) return
      dates.push(item.date)
    })
  })
  dates.sort().reverse()
  return dates
}
